import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { useRegionEndpoint } from '@/shared/hooks';

/**
 * 라우트 이동 시, 이미 정해진 리전 query 를 붙여주는 Effect Hook
 *
 * `region` query 가 없거나 현재 리전과 다르면 shallow replace 로 현재 리전을 붙입니다.
 */
const useRegionParamEffect = () => {
  const router = useRouter();
  const { query } = router;
  const { currentRegion } = useRegionEndpoint();

  useEffect(() => {
    const queryRegion = query.region;

    if (!queryRegion || queryRegion !== currentRegion) {
      router.replace(
        {
          pathname: router.pathname,
          query: { ...query, region: currentRegion },
        },
        '',
        { shallow: true },
      );
    }
  }, [currentRegion, query, router]);
};

export default useRegionParamEffect;
